"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LngStationFiltersSchema = exports.LngGasStationRouteResponseSchema = exports.LngGasStationRouteSchema = exports.LngGasStationAlongRouteSchema = exports.GasStationRouteRequestSchema = exports.ListLngGasStationsResponseSchema = exports.ListLngGasStationsQuerySchema = exports.LngGasStationPinSchema = exports.LngGasStationDtoSchema = exports.LngStationDetailsDtoSchema = exports.FuelCardDtoSchema = exports.LngStationSizeSchema = exports.LngStationSize = exports.AlternoilStationStatusWebhookResponseSchema = exports.AlternoilStationStatusResultSchema = exports.AlternoilStationStatusRequestSchema = exports.AlternoilStationStatusReportSchema = exports.AlternoilStationStatusEntrySchema = exports.AlternoilStationStatusSchema = exports.AlternoilStationStatus = exports.MAX_STATIONS_PER_STATUS_REPORT = exports.RouteWithGasStationsResultSchema = exports.GasStationAlongRouteSchema = exports.GasStationDtoSchema = exports.GasStationFuelTypeSchema = exports.GasStationFuelType = exports.GasStationCategorySource = exports.GasStationPrioritySchema = exports.GasStationPriority = exports.GasStationProviderSchema = exports.GasStationProvider = void 0;
const zod_1 = require("zod");
const geo_1 = require("./geo");
const routing_1 = require("./routing");
/** Raw data source a station was imported from — not the customer-facing network name. */
var GasStationProvider;
(function (GasStationProvider) {
    GasStationProvider["SHELL"] = "SHELL";
    GasStationProvider["HOYER"] = "HOYER";
    GasStationProvider["TANKPOOL24"] = "TANKPOOL24";
    GasStationProvider["DKV"] = "DKV";
    GasStationProvider["ALTERNOIL"] = "ALTERNOIL";
})(GasStationProvider || (exports.GasStationProvider = GasStationProvider = {}));
exports.GasStationProviderSchema = zod_1.z.nativeEnum(GasStationProvider);
/** Favorite (preferred) / Standard (fallback) / Emergency (last resort) — the green/yellow/red axis. */
var GasStationPriority;
(function (GasStationPriority) {
    GasStationPriority["FAVORITE"] = "FAVORITE";
    GasStationPriority["STANDARD"] = "STANDARD";
    GasStationPriority["EMERGENCY"] = "EMERGENCY";
})(GasStationPriority || (exports.GasStationPriority = GasStationPriority = {}));
exports.GasStationPrioritySchema = zod_1.z.nativeEnum(GasStationPriority);
/** Identifies which rule-run produced a `GasStationCategoryEntity` row. */
var GasStationCategorySource;
(function (GasStationCategorySource) {
    GasStationCategorySource["WERTHER_FAVORITES_V1"] = "werther-favorites-v1";
    GasStationCategorySource["WEIGAND_SHELL_V1"] = "weigand-shell-v1";
})(GasStationCategorySource || (exports.GasStationCategorySource = GasStationCategorySource = {}));
/** Fuel types a station may offer — mirrors the fixed diesel/lng/adblue/electric flag columns on `gas_station_fuel_types`. */
var GasStationFuelType;
(function (GasStationFuelType) {
    GasStationFuelType["DIESEL"] = "DIESEL";
    GasStationFuelType["LNG"] = "LNG";
    GasStationFuelType["ADBLUE"] = "ADBLUE";
    GasStationFuelType["ELECTRIC"] = "ELECTRIC";
})(GasStationFuelType || (exports.GasStationFuelType = GasStationFuelType = {}));
exports.GasStationFuelTypeSchema = zod_1.z.nativeEnum(GasStationFuelType);
/**
 * A company's fuel-network station, joined with its network-specific category
 * assignment (`gas_station_categories`). Never carries price data.
 */
exports.GasStationDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    address: zod_1.z.string().nullable(),
    lat: zod_1.z.number(),
    lon: zod_1.z.number(),
    priority: exports.GasStationPrioritySchema,
    isBetriebstank: zod_1.z.boolean(),
    fuelTypes: zod_1.z.array(exports.GasStationFuelTypeSchema).nullable(),
});
/** A gas station matched to a planned route, analogous to `RestAreaAlongRoute` for parking —
 * no availability/capacity fields, since fuel stations carry no occupancy concept. */
exports.GasStationAlongRouteSchema = exports.GasStationDtoSchema.extend({
    /** Distance from route start to this station in meters. */
    distanceFromStart: zod_1.z.number(),
    /** Air distance from the station to the nearest route coordinate in meters. */
    distanceFromRoute: zod_1.z.number(),
    /** Estimated arrival time (ISO string) at this station. */
    estimatedArrival: zod_1.z.string(),
    /** Total time to drive from the start to this station in seconds. */
    timeToStop: zod_1.z.number(),
});
exports.RouteWithGasStationsResultSchema = zod_1.z.object({
    routeCoordinates: zod_1.z.array(geo_1.coordSchema),
    totalDuration: zod_1.z.number(),
    totalDistance: zod_1.z.number(),
    boundingBox: zod_1.z.tuple([zod_1.z.number(), zod_1.z.number(), zod_1.z.number(), zod_1.z.number()]).optional(),
    gasStationsAlongRoute: zod_1.z.array(exports.GasStationAlongRouteSchema),
});
/** Alternoil's whole network is ~50 stations; bound what one report may carry. */
exports.MAX_STATIONS_PER_STATUS_REPORT = 2000;
/** Alternoil's `statusCode`; its `status` text is the German label of the same value. */
var AlternoilStationStatus;
(function (AlternoilStationStatus) {
    AlternoilStationStatus[AlternoilStationStatus["UNDER_MAINTENANCE"] = 0] = "UNDER_MAINTENANCE";
    AlternoilStationStatus[AlternoilStationStatus["IN_SERVICE"] = 1] = "IN_SERVICE";
})(AlternoilStationStatus || (exports.AlternoilStationStatus = AlternoilStationStatus = {}));
exports.AlternoilStationStatusSchema = zod_1.z.nativeEnum(AlternoilStationStatus);
exports.AlternoilStationStatusEntrySchema = zod_1.z.object({
    /** Matches `gas_stations.externalId`. */
    station: zod_1.z.string().min(1),
    statusCode: exports.AlternoilStationStatusSchema,
    /** Display text; never evaluated. */
    status: zod_1.z.string(),
});
exports.AlternoilStationStatusReportSchema = zod_1.z
    .object({
    timestamp: zod_1.z.string().min(1),
    count: zod_1.z.number().int().nonnegative(),
    stations: zod_1.z
        .array(exports.AlternoilStationStatusEntrySchema)
        .min(1)
        .max(exports.MAX_STATIONS_PER_STATUS_REPORT)
        .refine((stations) => new Set(stations.map((entry) => entry.station))
        .size === stations.length, { message: 'station codes must be unique' }),
})
    // Only guard against a report truncated in transit: Alternoil derives `count` from the same list.
    .refine((report) => report.count === report.stations.length, {
    message: 'count must match the number of reported stations',
    path: ['count'],
});
exports.AlternoilStationStatusRequestSchema = zod_1.z.tuple([exports.AlternoilStationStatusReportSchema]);
exports.AlternoilStationStatusResultSchema = zod_1.z.object({
    activated: zod_1.z.number().int().nonnegative(),
    deactivated: zod_1.z.number().int().nonnegative(),
    /** Reported station codes with no stored Alternoil station. */
    unknown: zod_1.z.number().int().nonnegative(),
});
/** Success envelope for `POST /gas-stations/alternoil/webhooks/stations`. */
exports.AlternoilStationStatusWebhookResponseSchema = zod_1.z.object({
    data: exports.AlternoilStationStatusResultSchema,
});
var LngStationSize;
(function (LngStationSize) {
    LngStationSize["XS"] = "XS";
    LngStationSize["XL"] = "XL";
})(LngStationSize || (exports.LngStationSize = LngStationSize = {}));
exports.LngStationSizeSchema = zod_1.z.nativeEnum(LngStationSize);
exports.FuelCardDtoSchema = zod_1.z.object({
    code: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.LngStationDetailsDtoSchema = zod_1.z.object({
    stationSize: exports.LngStationSizeSchema,
    lngPumps: zod_1.z.number().int().nonnegative(),
    lngLanes: zod_1.z.number().int().nonnegative(),
    hasBioLng: zod_1.z.boolean(),
});
exports.LngGasStationDtoSchema = exports.GasStationDtoSchema.pick({
    id: true,
    name: true,
    address: true,
    lat: true,
    lon: true,
}).extend({
    provider: exports.GasStationProviderSchema,
    isAvailable: zod_1.z.boolean(),
    openingHours: zod_1.z.string().nullable(),
    highway: zod_1.z.string().nullable(),
    services: zod_1.z.object({
        freeCoffee: zod_1.z.boolean().nullable(),
        washBay: zod_1.z.boolean().nullable(),
        tyrePressureCheck: zod_1.z.boolean().nullable(),
    }),
    fuelTypes: zod_1.z.array(exports.GasStationFuelTypeSchema),
    acceptedFuelCards: zod_1.z.array(exports.FuelCardDtoSchema),
    lngDetails: exports.LngStationDetailsDtoSchema.nullable(),
});
exports.LngGasStationPinSchema = exports.LngGasStationDtoSchema.pick({
    id: true,
    lat: true,
    lon: true,
    isAvailable: true,
});
exports.ListLngGasStationsQuerySchema = zod_1.z.object({
    provider: zod_1.z.literal(GasStationProvider.ALTERNOIL),
    fuelType: zod_1.z.literal(GasStationFuelType.LNG),
});
exports.ListLngGasStationsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.LngGasStationDtoSchema),
});
exports.GasStationRouteRequestSchema = exports.ListLngGasStationsQuerySchema.merge(routing_1.RouteRequestSchema);
exports.LngGasStationAlongRouteSchema = exports.LngGasStationDtoSchema.merge(exports.GasStationAlongRouteSchema.pick({
    distanceFromStart: true,
    distanceFromRoute: true,
    estimatedArrival: true,
    timeToStop: true,
})).extend({
    /** Only set when the route has a rest point. */
    isBeforeRestPoint: zod_1.z.boolean().optional(),
});
exports.LngGasStationRouteSchema = exports.RouteWithGasStationsResultSchema.extend({
    gasStationsAlongRoute: zod_1.z.array(exports.LngGasStationAlongRouteSchema),
    /** Route coordinate where the remaining driving time runs out; absent when the destination is reachable. */
    restPointIndex: zod_1.z.number().int().nonnegative().optional(),
});
exports.LngGasStationRouteResponseSchema = zod_1.z.object({
    data: exports.LngGasStationRouteSchema,
});
exports.LngStationFiltersSchema = zod_1.z.object({
    onlyAvailable: zod_1.z.boolean(),
    onlyBioLng: zod_1.z.boolean(),
    fuelCardCodes: zod_1.z.array(zod_1.z.string()),
    services: zod_1.z.object({
        freeCoffee: zod_1.z.boolean(),
        washBay: zod_1.z.boolean(),
        tyrePressureCheck: zod_1.z.boolean(),
    }),
});
//# sourceMappingURL=gas-station.js.map